import { calculateFormat } from '../../../../../../helper';
import { IControlProperties } from '../../../../entities/IControlProperties';
import { IDataGridColumn } from '../../entities';
import { CustomizedDxColumn } from './generateColumns';

export const setNumberBox = (
	bcColumn: IDataGridColumn<IControlProperties>,
	dxColumn: CustomizedDxColumn
) => {
	dxColumn.format = calculateFormat(bcColumn);
};
